import createPersistedState from "vuex-persistedstate";

export default {
  state: () => ({
    idNumber: "",
    fname: "",
    lname: "",
    full_name: "",
    street: "",
    city: "",
    email: "",
    no_limit: 0,
    refundToCard: false,
    refundToCardNoSetCount: -1,
    ordersCount: 0,
    time: "",
    token: "",
    weightsNumber: 0,
    creditsNumber: 0,
    currentUserId: null,
    totalLoginCartCount: 0,       
    allPhoneNumbers: [
      {
        tel: "",
        no_msg: 0,
      },
    ],
    whenToRemind: [
      {
        display: "תזכורת בפתיחת המערכת",
        type: "openingNewSale",
        value: 0,
      },
      {
        display: "תזכורת לפני סגירת המערכת",
        type: "beforeClosingSale",
        value: 0,
      },
      {
        display: "תזכורת ביום האיסוף",
        type: "dayOfPickup",
        value: 0,
      },
    ],
    whereToRemind: [
      {
        type: "phone",
        display: "טלפון",
        value: 0,
      },
      {
        type: "email",
        display: "מייל",
        value: 0,
      },
    ],
  }),
  getters: {
    getIdNumber: (state) => state.idNumber,
    getFname: (state) => state.fname,
    getFullName: (state) => state.full_name,
    getLname: (state) => state.lname,
    getCity: (state) => state.city,
    getStreet: (state) => state.street,
    getEmail: (state) => state.email,
    getAllPhoneNumbers: (state) => state.allPhoneNumbers,
    getWhenToRemind: (state) => state.whenToRemind,
    getWhereToRemind: (state) => state.whereToRemind,
    getToken: (state) => state.token,
    getNoLimit: (state) => state.no_limit,
    getRefundToCard: (state) => state.refundToCard,
    getRefundToCardNoSetCount: (state) => state.refundToCardNoSetCount,
    getOrdersCount: (state) => state.ordersCount,
    getTime: (state) => state.time,
    getTotalLoginCartCount: (s) => s.totalLoginCartCount,
    getCurrentUserId: (s) => s.currentUserId,
  },
  mutations: {
    setIdNumber(state, data) {
      state.idNumber = data;
    },
    setFname(state, data) {
      state.fname = data;
    },
    setFullName(state, data) {
      state.full_name = data;
    },
    setLname(state, data) {
      state.lname = data;
    },
    setStreet(state, data) {
      state.street = data;
    },
    setCity(state, data) {
      state.city = data;
    },
    setEmail(state, data) {
      state.email = data;
    },
    setToken(state, data) {
      state.token = data;
    },
    setNoLimit(state, data) {
      state.no_limit = data;
    },
    setRefundToCard(state, data) {
      state.refundToCard = data;
    },
    setRefundToCardNoSetCount(state, data) {
      state.refundToCardNoSetCount = data;
    },
    setOrdersCount(state, data) {
      state.ordersCount = data;
    },
    setTime(state, data) {
      state.time = data;
    },
    setCreditsNumber(state, data) {
      state.creditsNumber = data;
    },
    setWeightsNumber(state, data) {
      state.weightsNumber = data;
    },
    setAllPhoneNumbers(state, payload) {
      const { index, value } = payload;
      if (state.allPhoneNumbers[index]) {
        state.allPhoneNumbers[index].tel = value;
      } else {
        state.allPhoneNumbers[index] = { tel: value, no_msg: 0 };
      }
    },
    setPhoneRemind(state, payload) {
      const { index, value } = payload;
      state.allPhoneNumbers[index].no_msg = value;
    },
    setWhenToRemind(state, payload) {
      const { type, value } = payload;
      const reminder = state.whenToRemind.find((item) => item.type === type);
      if (reminder) {
        reminder.value = value;
      }
    },
    setWhereToRemind(state, payload) {
      const { type, value } = payload;
      const reminder = state.whereToRemind.find((item) => item.type === type);
      if (reminder) {
        reminder.value = value;
      }
    },
    addPhone(state, newPhone) {
      state.allPhoneNumbers.push(newPhone);
    },
    updateAllPhoneNumbers(state, phones) {
      state.allPhoneNumbers = phones;
    },
    deleteAllNullPhoneNumbers(state) {
      state.allPhoneNumbers = state.allPhoneNumbers.filter(
        (item) =>
          typeof item.tel === "number" ||
          (typeof item.tel === "string" && item.tel.trim().length > 0)
      );
      if (!state.allPhoneNumbers.length) {
        state.allPhoneNumbers = [{ tel: "", no_msg: 0 }];
      }
    },
    setCurrentUserId(state, id) { state.currentUserId = id; },
    setTotalLoginCartCount(s, n) { s.totalLoginCartCount = Number(n) || 0; },
  },
   actions: {
     initializeStore({ commit }) {
    },
   },
  plugins: [
    createPersistedState({
      paths: ["creditsNumber", "weightsNumber"]
    }),
  ],
  namespaced: true,
};





